import axios from 'axios'
import { useAuth } from '@/store/auth'


const baseURL = process.env.NEXT_PUBLIC_API_URL;

const api = axios.create({
    baseURL: baseURL,
    withCredentials: true,
})
api.interceptors.request.use(
    (config) => {
        const token = useAuth.getState().token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => Promise.reject(error)
)

export default api;
